import React, { useEffect, useRef, useState } from "react";
import OrgChart from "@balkangraph/orgchart.js"; // Import the library
import "./MyFamilyTree.css"; // Import the custom CSS file
import { useNavigate } from "react-router-dom";
import axios from "axios";

const MyFamilyTree = () => {
  const treeRef = useRef(null); // Reference for the tree container
  const [data, setData] = useState();

  let aimsUserMemberId = localStorage.getItem("aimsUserMemberId");

  useEffect(() => {
    if (aimsUserMemberId) {
      axios
        .post(
          `https://anoopam.com/aims/api/?action=getmember&memberid=${aimsUserMemberId}&formate=new`
        )
        .then((res) => {
          // setData(res?.data?.data?.member?.memberid)
          setData([
            {
              id: 1,
              pids: [2], // Connect to wife (id: 2)
              gender: "male",
              name: res?.data?.data?.member?.first_name,
              relationship: "",
            },
          ]);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [aimsUserMemberId]);

  useEffect(() => {
    if (!data || data.length === 0) return;
    const family = new window.FamilyTree(treeRef.current, {
      mouseScrool: window.FamilyTree.true,
      // mouseScrool: true,
      interactive: false,
      scaleInitial: 0.9,
      mode: "light",
      template: "hugo",
      roots: [3],
      // nodeMenu: {
      //   edit: { text: "Edit" },
      //   details: { text: "Details" },
      // },
      toolbar: {
        // layout: true,
        zoom: true,
        fit: true,
        // expandAll: true,
      },
      // nodeTreeMenu: true,
      nodeBinding: {
        field_0: "name", // Display name
        field_1: "relationship", // Display relationship
      },
      editForm: {
        titleBinding: "name",
        // photoBinding: "photo",
        // addMoreBtn: "Add element",
        addMore: "Add more elements",
        addMoreFieldName: "Element name",
        generateElementsFromFields: false,
        elements: [
          { type: "textbox", label: "Full Name", binding: "name" },

          { type: "textbox", label: "Relationship", binding: "relationship" },
        ],
      },
      // Adding the menu for exporting
      // menu: {
      //   pdfPreview: {
      //     text: "Export to PDF",
      //     icon: OrgChart.icon.pdf(24, 24, "#7A7A7A"),
      //     onClick: () => {
      //       family.exportPDF({
      //         format: "A4",
      //         landscape: true,
      //         filename: "FamilyTree.pdf",
      //       });
      //     },
      //   },
      //   csv: { text: "Save as CSV" },
      // },
    });

    // Load the family tree data
    // family.load([
    //   {
    //     id: 1,
    //     pids: [2], // Connect to wife (id: 2)
    //     gender: "male",
    //     name: "Shamjibhai Patel",
    //     relationship: "Grand Father",
    //   },
    //   {
    //     id: 2,
    //     pids: [1],
    //     gender: "female",
    //     name: "Parvatiben Patel",
    //     relationship: "Grand Mother",
    //   },
    //   {
    //     id: 3,
    //     mid: 1,
    //     fid: 2,
    //     pids: [5], // Connect to wife (id: 5)
    //     gender: "male",
    //     name: "Maheshbhai Patel",
    //     relationship: "Uncle",
    //   },
    //   {
    //     id: 4,
    //     mid: 1,
    //     fid: 2,
    //     pids: [6], // Connect to wife (id: 6)
    //     gender: "male",
    //     name: "Ghanshyambhai Patel",
    //     relationship: "Father",
    //   },
    //   {
    //     id: 5, // Wife of id: 3
    //     pids: [3],
    //     gender: "female",
    //     name: "Minakshiben Patel",
    //     relationship: "Aunty",
    //   },
    //   {
    //     id: 6, // Wife of id: 4
    //     pids: [4],
    //     gender: "female",
    //     name: "Manishaben Patel",
    //     relationship: "Mother",
    //   },
    //   {
    //     id: 7, // Son of Maheshbhai and Minakshiben Patel
    //     mid: 5, // Mother's ID
    //     fid: 3, // Father's ID
    //     gender: "male",
    //     name: "Sunil Patel",
    //     relationship: "Son",
    //   },
    //   {
    //     id: 8, // Daughter of Ghanshyambhai and Manishaben Patel
    //     mid: 6, // Mother's ID
    //     fid: 4, // Father's ID
    //     gender: "female",
    //     name: "Shreya Patel",
    //     relationship: "Daughter",
    //   },
    //   {
    //     id: 9, // Son of Ghanshyambhai and Manishaben Patel
    //     mid: 6, // Mother's ID
    //     fid: 4, // Father's ID
    //     pids: [10], // Connect to wife (id: 10)
    //     gender: "male",
    //     name: "Vishal Patel",
    //     relationship: "Son",
    //   },
    //   {
    //     id: 10, // Wife of Rajeshbhai Patel
    //     pids: [9],
    //     gender: "female",
    //     name: "Sapana Patel",
    //     relationship: "Daughter-in-law",
    //   },
    //   {
    //     id: 11, // Son of Rajeshbhai and Jagrutiben Patel
    //     mid: 10, // Mother's ID
    //     fid: 9, // Father's ID
    //     gender: "male",
    //     name: "Soham Patel",
    //     relationship: "Grand Son",
    //   },
    //   {
    //     id: 12, // Daughter of Rajeshbhai and Jagrutiben Patel
    //     mid: 10, // Mother's ID
    //     fid: 9, // Father's ID
    //     gender: "female",
    //     name: "Krishna Patel",
    //     relationship: "Grand Daughter In-law",
    //   },
    // ]);

    family.load(data);

    // Cleanup on component unmount
    return () => {
      family.destroy();
    };
  }, [data]);

  const navigate = useNavigate();

  return (
    <>
      <div className="col-12 m-auto overflow-x-auto">
        <div
          ref={treeRef}
          className="family-tree   "
          style={{
            height: "100%",
          }}
        ></div>
      </div>
      <button
        className="btn  "
        style={{
          position: "fixed",
          top: "80px",
          right: "10px",
          backgroundColor: " #034da2",
          color: "white",
          fontWeight: "600",
          fontSize: "1.1rem",
        }}
        onClick={() => navigate("/add-members")}
      >
        Add Members
      </button>
    </>
  );
};

export default MyFamilyTree;
